/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Talk_To_SellerInputs */

const en_talk_to_seller = /** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Talk to ${i?.name}`)
};

const es_talk_to_seller = /** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hablar con ${i?.name}`)
};

const fr_talk_to_seller = /** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parler à ${i?.name}`)
};

const de_talk_to_seller = /** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sprich mit ${i?.name}`)
};

const id_talk_to_seller = /** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bicara dengan ${i?.name}`)
};

/** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */
const ja_talk_to_seller = en_talk_to_seller;

/** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */
const zh_talk_to_seller = en_talk_to_seller;

/** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */
const ar_talk_to_seller = en_talk_to_seller;

/** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */
const it_talk_to_seller = en_talk_to_seller;

/** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */
const ru_talk_to_seller = en_talk_to_seller;

/** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */
const pt_talk_to_seller = en_talk_to_seller;

/** @type {(inputs: Talk_To_SellerInputs) => LocalizedString} */
const ko_talk_to_seller = en_talk_to_seller;

/**
* | output |
* | --- |
* | "Talk to {name}" |
*
* @param {Talk_To_SellerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const talk_to_seller = /** @type {((inputs: Talk_To_SellerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_To_SellerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_talk_to_seller(inputs)
	if (locale === "es") return es_talk_to_seller(inputs)
	if (locale === "fr") return fr_talk_to_seller(inputs)
	if (locale === "de") return de_talk_to_seller(inputs)
	if (locale === "ja") return ja_talk_to_seller(inputs)
	if (locale === "zh") return zh_talk_to_seller(inputs)
	if (locale === "ar") return ar_talk_to_seller(inputs)
	if (locale === "id") return id_talk_to_seller(inputs)
	if (locale === "it") return it_talk_to_seller(inputs)
	if (locale === "ru") return ru_talk_to_seller(inputs)
	if (locale === "pt") return pt_talk_to_seller(inputs)
	return ko_talk_to_seller(inputs)
});